import type { AiCostLimitPayload } from '@Application/AiCostLimits/Limits/Actions/aiCostLimitsFetched';
import type { AiCostLimitLevel } from '@Domain/AiCostLimits/AiCostLimitLevel';
import type { AiCostLimitState } from '@Domain/AiCostLimits/AiCostLimitState';

/** Immutable View: `readonly` properties, frozen at the end of the constructor. */
class AiCostLimitView {
	readonly id: number;
	readonly level: AiCostLimitLevel;
	readonly levelLabel: string;
	readonly subjectId: number;
	readonly monthlyAmount: number;
	readonly alertThresholdPercent: number;
	readonly state: AiCostLimitState;
	readonly stateLabel: string;
	readonly percent: number;

	constructor(payload: AiCostLimitPayload) {
		this.id = payload.id;
		this.level = payload.level.value;
		this.levelLabel = payload.level.label;
		this.subjectId = payload.subjectId;
		this.monthlyAmount = payload.monthlyAmount;
		this.alertThresholdPercent = payload.alertThresholdPercent;
		this.state = payload.status.state.value;
		this.stateLabel = payload.status.state.label;
		this.percent = payload.status.percent;

		Object.freeze(this);
	}

	/** Read from the server's state, never recomputed: at or past the limit, no new processing starts. */
	get isBlocking(): boolean {
		return this.state === 'reached' || this.state === 'exceeded';
	}

	get statusSeverity(): 'success' | 'warning' | 'danger' {
		if (this.isBlocking) {
			return 'danger';
		}

		return this.state === 'alert' ? 'warning' : 'success';
	}
}

export default AiCostLimitView;
